import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import { HBox, VBox } from "@ui/box/Box";
import Signal from "badmfck-signal";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";

export const S_LIST_VALUES_POPUP = new Signal<{
	title: string;
	value: object;
} | null>("S_LIST_VALUES_POPUP");

export const ListValuesPopup = () => {
	useLocale();
	const requestData = S_LIST_VALUES_POPUP.use();

	if (!requestData) return null;

	const closePopup = () => {
		S_LIST_VALUES_POPUP.invoke(null);
	};

	const value = requestData.value;
	// if (value.indexOf('==') === value.length - 2) {
	// 	try {
	// 		value = atob(value);
	// 	} catch (e) {
	// 		console.error("Error decoding base64:", e);
	// 	}
	// }

	return (
		<Panel
			sx={{
				width: "600px",
				maxWidth: "1200px",
				height: "90vh",
				padding: "0",
				minWidth: "500px",
				maxHeight: "90vh",
			}}
			decorator="absolute"
			// growContent
			// scrollable
			label={requestData.title}
			onClose={closePopup}>
			<VBox sx={{ overflow: "auto", flex: 1 }}>
				{Object.entries(value).map(([key, val]) => (
					<HBox gap="10px" key={key} sx={{ padding: "10px", borderBottom: "1px solid #0000001f", justifyContent: "space-between" }}>
						<Typo variant="medium" sx={{ minWidth: "150px", fontWeight: 600 }}>
							{key}:
						</Typo>
						<Typo variant="medium">{String(val)}</Typo>
					</HBox>
				))}
			</VBox>

			<Spacer size="20px" />

			<HBox sx={{ justifyContent: "end" }}>
				<Button
					title={msg("close")}
					variant="secondary"
					onClick={() => {
						closePopup();
					}}
				/>
			</HBox>
		</Panel>
	);
};
